import { ToastProgrammatic as Toast } from 'buefy'

const state = () => ({});

const actions = {
    showError( _, msg) {
        Toast.open({
            duration: 2500,
            message: msg,
            position: 'is-top',
            type: 'is-danger'
        })
    },
    showSuccess( _, msg) {
        Toast.open({
            duration: 2500,
            message: msg,
            position: 'is-top',
            type: 'is-success'
        })
    }
};

const getters = {};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};